import apiClient from './apiClient/bingohome'
import {Company} from  '../types'

export function getCompanyDetail(companyId:number): Promise<Company.Detail> {
  return apiClient.get('getCompanyDetail.do', {
    params: {
      companyId,
    },
  });
}

export function getSameCompanyNameList(params: {
  pageNo: Number;
  pageSize: Number;
  companyName: String;
  province: String;
  city: String;
  personId: String;
}): Promise<{ data: { data: Company.SameCompanyNameRes[] } }> {
  return apiClient.post('company/name/repeat', { ...params });
}

export function checkCompanyName(params: {
  companyName: string;
  province: string;
  city: string;
}): Promise<{ data: { data: true | false } }> {
  return apiClient.post('company/name/check', { ...params });
}
export function joinSend(params: {
  joinPersonId: string;
  remark: string;
  companyId: number;
}): Promise<{ data: { code: string } }> {
  return apiClient.post('company/join/send', { ...params });
}
export function getPhoneNumber(
  personId: number,
): Promise<{ data: { personId: number; telephone: string } }> {
  return apiClient.get('getTelephoneByPersonId.do', { params: { personId } });
}

export function createCompany(params: Company.CreateComParam): Promise<Company.CreateComRes> {
  return apiClient.post('createCompany.do', null, { params });
}

export function getInviteInfo(params: {inviteId: string,inviteType: string}): Promise<{data:{
  name: string,
  qrUrl: string,
  rid: string
}}> {
  return apiClient.get('getInviteInfo.do', { params });
}



export function generateShortUrl(params: {url: string,type: string}): Promise<{data:{
  shortUrl: string
}}> {
  return apiClient.get('wx/generateShortUrl.do', { params });
}
